module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_07_fc434e057.png";